import { compile as compilePath } from 'path-to-regexp';

export function isUrlActive(
  basePath: string,
  currentLocationPath: string = window.location.pathname,
  exact: boolean = false
) {
  if (exact) {
    return basePath === currentLocationPath;
  }

  return currentLocationPath.includes(basePath);
}

export function compileRouteUrl(
  routeUrl: string,
  pathParameters: Record<string, string | number>
): string {
  return compilePath(routeUrl === '*' ? '(.*)' : routeUrl)(pathParameters);
}
